import { Link } from "react-router-dom";
import "./SampleProjects.css";

import webSample1 from "../../../../Assets/Images/Pantomime.jpg";
import webSample2 from "../../../../Assets/Images/CourseSale.png";
import webSample3 from "../../../../Assets/Images/RolesAndPermissions.png";
import webSample4 from "../../../../Assets/Images/web-sample4.svg";
import webSample5 from "../../../../Assets/Images/HomePage1.png.jpg";
import webSample6 from "../../../../Assets/Images/PsEnv.jpg";
import webSample7 from "../../../../Assets/Images/UnHooked.jpg";
import webSample8 from "../../../../Assets/Images/web-sample8.jpg";
import webSample9 from "../../../../Assets/Images/web-sample9.png";
import webSample10 from "../../../../Assets/Images/Cargo.jpg";
import arrowRightIconWhite from "../../../../Assets/Icons/arrow-right-icon-white.svg";

const SampleProjects = () => {
  const projects = [
    {
      id: 1,
      title: "Pantomime",
      tags: ["Education", "Edu-Tech"],
      description:
        "Pantomime is an inclusive digital education platform built to support individuals with hearing and physical impairments. The project focuses on delivering interactive, accessible, and user-friendly learning experiences that remove traditional barriers to education. With a strong emphasis on usability and inclusivity, Pantomime enables learners to access quality educational content anytime, anywhere, while fostering communication and engagement through modern web technologies.",
      image: webSample1,
    },
    {
      id: 2,
      title: "Course Sale",
      tags: ["Educational", "IT Courses"],
      description:
        "Course Sale is a modern e-learning platform designed to make skill-based education simple, accessible, and practical. It offers a wide range of IT and professional courses, including programming and emerging technologies, curated by experienced instructors. Learners can browse courses easily, track progress, and gain real-world skills that align with current industry demands, all within an intuitive and responsive interface.",
      image: webSample2,
    },
    {
      id: 3,
      title: "Infinigent",
      tags: ["Business", "Management"],
      description:
        "Infringent is a robust internal management and monitoring system built to streamline operational workflows and data handling. The platform focuses on efficiency, accuracy, and scalability, providing administrators with clear insights through structured data views and reporting tools. Designed for day-to-day business operations, Infringent helps teams manage complex information with ease and confidence.",
      image: webSample3,
    },
    {
      id: 4,
      title: "Sundarban Cargo Service",
      tags: ["Business", "Management"],
      description:
        "Sundarban Cargo Service is a cross-border parcel delivery platform connecting the United Kingdom and Bangladesh. The system enables users to book shipments online, view real-time pricing, and complete secure payments seamlessly. The platform includes a dedicated operations dashboard where staff can manage bookings, track parcels, and control the delivery workflow through scan-based checkpoints. Customers also have access to a personalized portal to monitor their shipment status at every stage, ensuring transparency, reliability, and an efficient end-to-end delivery experience.",
      image: webSample10,
    },
    {
      id: 5,
      title: "Go Taste",
      tags: ["Food", "Restaurant"],
      description:
        "Go Taste is a visually engaging food and restaurant platform focused on showcasing menus, promotions, and dining experiences. The project combines strong visual design with smooth user interaction to create an appealing digital presence for food businesses. It helps attract customers, highlight featured items, and enhance online engagement through a modern and responsive layout.",
      image: webSample5,
    },
    {
      id: 6,
      title: "PS Environmental Services INC",
      tags: ["Business", "Engineering"],
      description:
        "This project delivers a professional corporate website for an environmental services company, emphasizing trust, expertise, and industry credibility. The platform clearly presents services, company values, and key information in a structured and accessible manner. Designed with performance and clarity in mind, it strengthens the company’s online presence and supports customer engagement.",
      image: webSample6,
    },
    {
      id: 7,
      title: "Unhooked",
      tags: ["Health", "Psycho Therapy"],
      description:
        "Unhooked is a modern, user-centric platform focused on awareness, support, and guidance around mental and emotional well-being. The project prioritizes clear communication, calming design, and accessibility to create a safe and welcoming digital space. It aims to help users better understand challenges, explore solutions, and take positive steps toward personal growth and well-being.",
      image: webSample7,
    },
    {
      id: 8,
      title: "Gaarx",
      tags: ["Business", "Road Side Assistance"],
      description:
        "Gaarx is a U.S.-based emergency roadside assistance platform designed to provide fast and reliable support to drivers in need. The service connects users with nearby assistance for breakdowns, towing, fuel delivery, tire changes, and other roadside emergencies. In addition to its assistance services, Gaarx also operates an online marketplace for car and bike parts, offering customers a convenient way to purchase quality components across the United States.",
      image: webSample8,
    },
    {
      id: 9,
      title: "Byte Tech",
      tags: ["IT Services", "Security & Infrastructure"],
      description:
        "Byte Tech Canvus is a full-spectrum technology partner that helps businesses accelerate growth through strategic and innovative software solutions. The platform offers a wide range of services including offshore development, custom web development, business analysis, data analytics, and advanced consulting — all designed to elevate your digital presence and operational performance. With a focus on scalable solutions, cloud security, and infrastructure optimization, Byte Tech Canvus combines expert technical capabilities with deep industry insight to deliver reliable, future-ready outcomes that drive measurable business value.",
      image: webSample9,
    },
  ];

  return (
    <section id="samples" className="sample-projects">
      <div className="sample-projects__header">
        <h2 className="sample-projects__title">
          Proof That The Web Work Holds Up
        </h2>
        <Link to="/contact-us/build-business">
          <button className="sample-projects__button">
            See What We’ve Built
            <img
              src={arrowRightIconWhite}
              alt="arrow right icon"
              className="arrow-icon"
            />
          </button>
        </Link>
      </div>

      <div className="sample-projects__grid">
        {projects.map((project) => (
          <div key={project.id} className="sample-projects__item">
            <div className="sample-projects__content">
              <div className="sample-projects__tags">
                {project.tags.map((tag, tagIndex) => (
                  <span key={tagIndex} className="sample-projects__tag">
                    {tag}
                  </span>
                ))}
              </div>
              <h3 className="sample-projects__project-title">
                {project.title}
              </h3>
              <p className="sample-projects__description">
                {project.description}
              </p>
            </div>
            <div className="sample-projects__image-container">
              <img
                src={project.image}
                alt={project.title}
                className="sample-projects__image"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SampleProjects;
